import { Box, Typography } from '@mui/material';
import { asyncHandler } from '../../../utils/async-handler';
import { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import {
	CambiappContext,
	CambiappContextType,
	IAvailableAppointments,
} from '../../../context/cambiapp.context';
import { CommonButton } from '../../button/common-button';
import { AppointmentPicker } from '../../appointment-picker.component';
import { InformationTooltip } from '../../tooltip/information-tooltip';

export const ThirdStepComponent = ({ previousStep, nextStep }: any) => {
	const { setSelectedAvailableAppointments, orderAmr, setOrderAmr } =
		useContext(CambiappContext) as CambiappContextType;
	const [appointments, setAppointments] = useState<any[]>([]);
	const hourValue = orderAmr.split(':')[0];
	const minutesValue = orderAmr.split(':')[1];
	const [time, setTime] = useState(
		moment()
			.utc(true)
			.add(hourValue, 'hours')
			.add(minutesValue, 'minutes')
			.format(),
	);
	const [selectedDates, setSelectedDates] = useState<IAvailableAppointments[]>(
		[],
	);

	useEffect(() => {
		setSelectedDates([]);
		const retrieveAppointments = async () => {
			let dates;
			if (hourValue && minutesValue)
				setTime(
					moment()
						.utc(true)
						.add(hourValue, 'hours')
						.add(minutesValue, 'minutes')
						.format(),
				);
			dates = await asyncHandler.fetchAppointments(time);
			setAppointments(dates);
		};
		retrieveAppointments();
	}, [hourValue, minutesValue, time]);

	useEffect(() => {
		setSelectedDates(
			selectedDates
				.sort((a, b) => {
					if (a.shift.split(':')[0] === b.shift.split(':')[0]) {
						if (a.shift.split(':')[1] > b.shift.split(':')[1]) return 1;
						if (a.shift.split(':')[1] < b.shift.split(':')[1]) return -1;
					}
					if (a.shift.split(':')[0] > b.shift.split(':')[0]) return 1;
					if (a.shift.split(':')[0] < b.shift.split(':')[0]) return -1;
					return 0;
				})
				.sort((a, b) => {
					if (a.date.split('T')[0] > b.date.split('T')[0]) return 1;
					if (a.date.split('T')[0] < b.date.split('T')[0]) return -1;
					return 0;
				}),
		);
	}, [selectedDates]);

	const handleNextStep = () => {
		if (selectedDates.length > 0) {
			setOrderAmr(`${hourValue}:${minutesValue}`);
			setSelectedAvailableAppointments(selectedDates);
			nextStep();
		}
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				padding: '25px',
			}}
		>
			<Typography
				sx={{
					textAlign: 'center',
					fontWeight: 600,
					fontSize: 18,
					marginBottom: '50px',
				}}
			>
				Citas posibles
			</Typography>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					marginBottom: '25px',
				}}
			>
				<Typography
					sx={{
						fontWeight: 800,
						margin: '0 20px',
						textAlign: 'justify',
					}}
				>
					Seleccionar qué días y horarios alternativos proponés para la cita de
					transacción en la Casa
				</Typography>
				<InformationTooltip
					title={`La cita es la fecha y hora en la que se realizará la transacción en la Casa. Seleccioná una, varias, o todas las citas alternativas que se encuentren disponibles. El vendedor que acepte tu demanda elegirá una de esas alternativas, y la misma quedará fijada como cita de transacción, no pudiendo modificarse.`}
				/>
			</Box>
			<AppointmentPicker
				appointments={appointments}
				selectedDates={selectedDates}
				setSelectedDates={setSelectedDates}
			/>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				<CommonButton
					action={previousStep}
					sxBgcolor={'#666666'}
					maxHeight="40px"
				>
					<Typography fontSize={12} color={'white'} fontWeight={600}>
						ATRÁS
					</Typography>
				</CommonButton>
				<CommonButton
					action={handleNextStep}
					sxBgcolor={'#05A550'}
					maxHeight="40px"
				>
					<Typography fontSize={12} color={'white'} fontWeight={600}>
						CONTINUAR
					</Typography>
				</CommonButton>
			</Box>
		</Box>
	);
};
